import React, {Dispatch, SetStateAction, useCallback} from "react";
import {ProjectEntity} from "../../api/entities";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import moment from 'moment';
import {SimulationState} from "../../api/entities/replancity_RunnedAlgorithm";
import {useTheme} from "../../context/themeContext";
import {themeColors} from "../../styles/theme";
import {ImagePlaceholder} from "../icons/icons/ImagePlaceholder";
import {getSimulationState, getSimulationStateColor} from "../../utils/utils";
import {PencilIcon} from "../icons/icons/PencilIcon";
import {IconButton} from "../buttons/IconButton/IconButton";


interface Props {
  projects: Array<ProjectEntity>;
  onModelClickHandler: any;
  setProjectEditing: Dispatch<SetStateAction<ProjectEntity | null>>
}

const ProjectsGrid: React.FC<Props> = ({projects, onModelClickHandler, setProjectEditing}) => {
  const {t} = useTranslation();
  const {theme} = useTheme();

  const projectEditHandler = useCallback((event, project: ProjectEntity) => {
    event.stopPropagation();
    event.preventDefault();

    setProjectEditing(project);
  }, [setProjectEditing])

  return (
    <div className="grid-wrapper">
      {projects.map((project) => {
        return (
          <Link
              key={project.id}
              onClick={() => onModelClickHandler(project.projectName)}
              to={`/${project.id}`}
          >
            <div
              className={`grid-elements ${theme}`}
              data-testid={`project-row_${project.id}`}
            >
              <div className="grid-elements-content">
                <div className={`flex-img ${theme}`}>
                  <ImagePlaceholder
                    width={95}
                    height={95}
                    color={theme === 'light' ? themeColors.textGrey : themeColors.navyBlue}
                    backgroundColor={theme === 'light' ? themeColors.lightGrey : themeColors.grey3}
                  />
                </div>
                <div className="card-content">
                  <div className="card-text">
                    <span className={`grid-elements-content__header ${theme}`}>{project.projectName}</span>
                    <span className={`content-text ${theme}`}>
                        {t('common.last-update-date')}: {moment(project.updateTs).format('YYYY-MM-DD HH:mm:ss')}
                       </span>
                    <span className={`content-text ${theme}`}>
                         {t('projects-main.simulation-state')}:
                         <span
                             className="simulation-state"
                             style={{
                               'color': themeColors.navyBlue,
                               'marginLeft': '5px',
                               'background': getSimulationStateColor(project.simulationState! as SimulationState)
                             }}
                         >
                          {getSimulationState(project.simulationState as SimulationState, t)}
                         </span>
                       </span>
                  </div>
                  <div className="card-buttons">
                    <IconButton
                        icon={PencilIcon}
                        onClick={(event) => projectEditHandler(event, project)}
                        data-testid={`edit_project_${project.id}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })
      }
    </div>
  );
};
export default ProjectsGrid;
